import { render, staticRenderFns } from "./AlertEventDialogEventsTabComponent.vue?vue&type=template&id=09433022&scoped=true"
import script from "./AlertEventDialogEventsTabComponent.js?vue&type=script&lang=js&external"
export * from "./AlertEventDialogEventsTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertEventDialogEventsTabComponent.vue?vue&type=style&index=0&id=09433022&prod&scoped=true&lang=scss"
import style1 from "./AlertEventDialogEventsTabComponent.vue?vue&type=style&index=1&id=09433022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09433022",
  null
  
)

export default component.exports